import React from 'react';
import { newToastMessage } from '@Containers/ToastMessages/ToastMessagesActions';
import { ChangedToastMessageTitle, ChangedToastMessageContent } from './ChangedToastMessage';

// eslint-disable-next-line import/prefer-default-export
export const showChangedToastMessage = ({ title, content }) =>
  newToastMessage({
    iconId: '#icon-check-circle',
    ...(title && { title: <ChangedToastMessageTitle title={title} /> }),
    ...(content && { content: <ChangedToastMessageContent content={content} /> }),
    className: 'changed-toast-message',
    color: 'confirm',
  });
